export default __webpack_public_path__ + "static/media/server.7a32953f.svg";